/* eslint-disable */
import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => createStyles({
  adornedEnd: {
    '& g *': {
      stroke: '#a2a9a9'
    },
    width: theme.spacing(2),
    height: theme.spacing(2),
    boxSizing: 'content-box',
    paddingRight: theme.spacing(1),
  },
  root: {
    width: '292px',
    height: "30px",
    padding: "4px 12px",
    background: "rgba(51, 51, 51, 0.05)",
    borderColor: "rgba(43, 57, 64, 0.07)",
    borderRadius: "4px",
    borderStyle: "solid",
    borderWidth: "1px",
    "&:before": {
      display: "none"
    },
    "&:after": {
      display: "none"
    },
    "&.focus": {
      borderColor: theme.palette.primary.main
    }
  },
  formControl: {
    "&.focus": {
      borderColor: theme.palette.primary.main
    }
  },
  disabled: {},
  underline: {},
  error: {},
  multiline: {},
  fullWidth: {},
  input: {
    userSelect: "none",
    fontSize: '14px',
    lineHeight: '17px',
  },
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {}
}));